<!--
 * @Description: 加油卡券
 * @Author: yl
 * @Date: 2021-06-08 16:16:31
 * @LastEditTime: 2021-06-10 17:32:41
 * @LastEditors: yl
-->
<template>
    <div class="topbar-container">
        <zbList v-model="store" class="v-list" v-slot:default="{ item }">
            <div class="item bg-100 bh bstart" :class="item.itemCls" @click="onInfoClick(item)">
                <div class="left bv">
                    <div class="value bh basestart">
                        <span class="fz_40">￥</span><span class="fz_60">{{item.goodsPrice}}</span>
                    </div>
                    <div class="c_black fz_30">{{item.goodsName}}</div>
                    <div class="time c_333 fz_20">
                        <span>下单:{{formattStringTime(item.insertAt)}}(兑换后一年内有效)</span>
                    </div>
                </div>
                <div class="bv right bc">
                    <div class="ico bg-contain"></div>
                    <div class="fz_34">立即加油</div>
                </div>
            </div>
        </zbList>
        <van-dialog v-model="dialog" title="提示" :closeOnClickOverlay="true" :closeOnPopstate="false"
            @cancel='closeDialog' confirmButtonText='好的' confirmButtonColor='#FF9A2B'>
            <div class="p0_30 p30_0">
                <couponKeys :code='code' :isNoShowLabel='true'></couponKeys>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { getGasCouponsList } from "@/api/user";
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import zbList from "@/components/data/List";
import couponKeys from "./components/gasCouponKeys";
import utils from "@/utils/index";
export default {
    mixins: [list, user],
    components: { zbList, couponKeys },
    name: "UserCouponsGas",
    data() {
        return {
            // 卡券
            store: {
                proxy: {
                    pageParam: "currentPage",
                    getList: getGasCouponsList,
                    disposeItem(item) {
                        const itemCls = "couponsnormal";
                        // // 是否可以兑换
                        // const isUse = item.isExchange == "未兑换";
                        // if (!isUse) {
                        //     itemCls = "couponstaboo";
                        // }
                        // item.isUse = isUse;
                        item.itemCls = itemCls;
                    }
                }
            },
            dialog: false,
            code: null
        };
    },
    computed: {
        isUpdateList() {
            return false;
        }
    },
    // // 监听是否更新列表数据
    // isUpdateList: {
    //     handler(v) {
    //         if (v) {
    //             this.storeReLoad();
    //         }
    //     },
    //     immediate: true
    // },
    methods: {
        onInfoClick({ redeemCode }) {
            this.code = redeemCode
            this.dialog = true
        },
        userLoginend() {
            const me = this;
            me.storeLoad({
                cusId: me.$store.getters.userInfo.id
            });
        },
        closeDialog() {
            this.dialog = false
        },
        formattStringTime(val) {
            return utils.formattStringTime(val)
        }
    }
};
</script>
<style scoped lang="scss">
.v-list {
    background-color: #f7f8f8;
    /deep/ .list-item {
        padding: 12px 30px 0 30px;
        &:first-child {
            padding: 24px 30px 0 30px;
        }
        &:last-child {
            padding: 12px 30px;
        }
    }
    .item {
        height: 200px;
        &.couponsnormal {
            background-image: url("~@/assets/imges/user/gasCouponsBg.png");
        }
        &.couponstaboo {
            color: #aaaaaa;
            background-image: url("~@/assets/imges/user/gasCouponsBg.png");
        }
        .left {
            width: 410px;
            padding-left: 55px;
            .value {
                color: #764e14;
            }
            .time {
                opacity: 0.8;
            }
            .ico {
                background-image: url("~@/assets/imges/ico/user/car.png");
                width: 46px;
                height: 38px;
                margin-right: 10px;
            }
        }
        .right {
            color: white;
            width: 180px;
            .ico {
                margin-top: -30px;
                background-image: url("~@/assets/imges/user/oil.png");
                width: 90px;
                height: 90px;
            }
        }
    }
}
</style>